<template>
  <v-card>
    <v-card-title class="text-headline-small bg-grey-lighten-2" primary-title>
      Modifier le nom d'un assemblage <br />
      ({{ payload.composite.name }})
    </v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-form v-model="valid" @submit.prevent="confirm" ref="form">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Nom personnalisé"
                :rules="[rules.required]"
                v-model="jobCompositeName"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="text" @click="close">Annuler</v-btn>
      <v-btn color="primary" variant="text" @click="confirm" :disabled="!valid"> Confirmer </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { DialogPropsMixin } from '@/components/dialog/mixins';
import { UpdateJobCompositeName } from '@/_services/composites';

export default {
  name: 'CompositeUpdateDialog',
  mixins: [DialogPropsMixin],
  data() {
    return {
      valid: true,
      rules: {
        required: value => !!value || 'Champ requis.',
      },
      jobCompositeName: '',
      errors: {
        name: false,
      },
    };
  },
  methods: {
    close() {
      this.errors = {
        name: false,
      };
      this.$refs.form.reset();
      this.$emit('close');
    },
    confirm() {
      if (this.valid) {
        this.$emit('loading');
        UpdateJobCompositeName(this.payload.composite.id, this.jobCompositeName)
          .then(() => {
            this.$store.dispatch('job/updateCompositeName', {
              compositeId: this.payload.composite.id,
              jobCompositeName: this.jobCompositeName,
              phaseId: this.payload.phaseId,
            });
          })
          .catch(error => {
            this.$store.dispatch('snackbar/set', error);
          })
          .finally(() => {
            this.$emit('loading', false);
            this.close();
          });
      }
    },
  },
  mounted() {
    this.jobCompositeName = this.payload.composite.jobCompositeName
      ? this.payload.composite.jobCompositeName
      : this.payload.composite.name;
  },
};
</script>
